import { Button } from "@/components/ui";
import { useState } from "react";
import type { LabOrderEntryActionSummary } from "../../network/useLabOrdersByEncounter";
import { useRetrieveAOEForOrder } from "../../network/useRetrieveAOEForOrder";
import { AOEDialog } from "./AOEDialog";

export const AOE = ({
  patientId,
  encounterId,
  requestGroupId,
  actionSummary,
  readOnly,
}: {
  patientId: string;
  encounterId: string;
  requestGroupId: string;
  actionSummary: LabOrderEntryActionSummary;
  readOnly: boolean;
}) => {
  const [isAOEModalOpen, setIsAOEModalOpen] = useState(false);
  const {
    data: orderAOEData,
    isFetching: isFetchingOrderAOE,
    isError: isErrorOrderAOE,
  } = useRetrieveAOEForOrder({
    patientId,
    requestGroupId: requestGroupId,
  });

  const buttonVariant = isErrorOrderAOE
    ? "danger"
    : actionSummary.aoeSatisfied
      ? "secondary"
      : "primary";

  const buttonText = isFetchingOrderAOE
    ? "Loading AOE"
    : isErrorOrderAOE
      ? "AOE Failed to Load"
      : actionSummary.aoeSatisfied
        ? "AOE Answered"
        : "AOE Required";
  return (
    <div>
      <Button
        variant={buttonVariant}
        size="xs"
        className="w-full"
        onClick={() => setIsAOEModalOpen(true)}
        disabled={readOnly || isFetchingOrderAOE}
        isLoading={isFetchingOrderAOE}
        hideTextOnLoading={false}
      >
        {buttonText}
      </Button>
      {isAOEModalOpen && (
        <AOEDialog
          close={() => setIsAOEModalOpen(false)}
          patientId={patientId}
          encounterId={encounterId}
          requestGroupId={requestGroupId}
          questionnaires={orderAOEData?.aoeQuestionnaires ?? []}
        />
      )}
    </div>
  );
};
